export default __webpack_public_path__ + "static/media/img-newsletter-nft-usa.06fbbb3b.png";